import { useEffect, useState } from 'react';
import { Grid } from '@mui/material/';
import { ResponsiveAppBar } from '../../components';
import makeStyles from '@mui/styles/makeStyles';
import { DataGrid, GridRowsProp, GridColDef } from '@mui/x-data-grid';
import { useWallet, useConnection } from '@solana/wallet-adapter-react';
import axios from 'axios';
import GenericPageLoading from '../../components/Loaders/GenericPageLoading';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import {startOfDayLocal, addDays} from '../../utils/date'
import { useAppStore } from '../../store/AppStore';
import {genName} from "./BetSlip/nameGen.js";
import {MainDomain, findMainDomain} from "@onsol/tldparser";
import { PublicKey } from '@solana/web3.js';

const useStyles = makeStyles((theme) => ({
    root: {
      minHeight: '100vh', // Full screen height
      paddingTop: 110, // on Small screen
      [theme.breakpoints.up('sm')]: {
        paddingTop: 110, // on Large screen
      },
    },
    header: {},
    toolbar: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
    title: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      flexGrow: 1,
      textAlign: 'center',
      whiteSpace: 'nowrap',
    },
    content: {
      flexGrow: 1, // Takes all possible space
      padding: theme.spacing(1),
    },
    footer: {},
  }));


const Leaderboard = () => {

	const [appState, dispatch] = useAppStore();
	const { connection } = useConnection();
    const classes = useStyles();
    const wallet = useWallet();
    const [history, setHistory] = useState([]);
	const todayStart = startOfDayLocal(new Date());
	const [dayRange, setDayRange] = useState({from: addDays(todayStart, -1), to: todayStart });
	const [init, setInit] = useState(true);
	const [searching, setSearching] = useState(false);

	async function getDomains(pubkeys) {
		const map = {}
		const batchSize = 100
		for(let x=0; x<pubkeys.length; x+=batchSize){
			const usePubkeys = pubkeys.slice(x, x+batchSize)
			const mainDomainKeys = usePubkeys.map((pubkey) => findMainDomain(pubkey)[0]);
			const mainDomainAccounts = await connection.getMultipleAccountsInfo(mainDomainKeys);
			usePubkeys.forEach((pubkey, index) => {
				const mainDomainAccount = mainDomainAccounts[index];
				if (!!mainDomainAccount?.data) {
					const mainDomainData = MainDomain.fromAccountInfo(mainDomainAccount)[0];
					map[pubkey.toString()] = mainDomainData.domain + mainDomainData.tld;
				}else{
					map[pubkey.toString()] = false;
				}
			});
		}
		return map
	};
	
	const fetchHistory = async () => {
		if (wallet.publicKey){
			setSearching(true);
			const addr = wallet.publicKey.toBase58();
			const pointsData = await axios.get(`https://api.purebet.io/purebet/points-api?all=${addr}`);
			const domains = await getDomains(pointsData.data.map(h => new PublicKey(h.address)))
			let history = pointsData.data.map((h, i) => { 
				if(i == 0){h.rank = "YOU"}else{h.rank = i}
				h.nickname = genName(h.address)
				h.address = domains[h.address] || h.address
				h.total = h.total.toLocaleString()
				h.season1points = h.season1points.toLocaleString()
				h.season2points = h.season2points.toLocaleString()
				return {...h, id: i} 
			})
			setSearching(false);

			// history = dataSample; //For testing
			setHistory(history);
		}
		else {
			setHistory([]);
		}
		setInit(false);
		
	};

	const searchHistory = () => {
		fetchHistory().catch(console.error);
	}

	const noDataOverlay =  () => {
		return (
				<> { searching ? 
					(<GenericPageLoading/>) : 
					(<div style={{ paddingTop: '20px', width: '100%', textAlign: 'center' }}>{ init ? '' : 'No bets in this time period'}</div>) 
					} 
				</>
		);
	};
    
    useEffect(() => {
		if (!wallet.publicKey) return;
	 }, []);
      

	const columns = [
	{ field: 'rank', headerName: 'Rank', flex: 1},
	{ field: 'address', headerName: 'Address', flex: 3},
	{ field: 'nickname', headerName: 'Nickname', flex: 3},
	{ field: 'season2points', headerName: 'S2 Points', flex: 3, type: "number"},
	{ field: 'season1points', headerName: 'S1 Points', flex: 3, type: "number"},
	{ field: 'total', headerName: 'Total Points', flex: 3, type: "number"},
	];

    return (
        <Grid container direction="column" className={classes.root}>
            <Grid item className={classes.header} component="header">
                <ResponsiveAppBar />
            </Grid>

            <Grid item className={classes.content} component="main">
                <div style={{ height: 800, maxheight: 1200,  width: '95%', margin: 'auto' }}>

					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<Stack spacing={1} direction="row" sx={{ mb: 1, mt: 1 }} >
							<Button variant="contained" size="medium" onClick={searchHistory}>Connect your wallet and click here to see the leaderboard and where you are!</Button>
						</Stack>
					</LocalizationProvider>

                    <DataGrid  
						slots={{ noRowsOverlay: noDataOverlay }} 
						getRowHeight={() => 'auto'}
						sx={{
							'&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '8px' },
							'&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '15px' },
							'&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '22px' },
						  }}
						rows={history} columns={columns} autoHeight={true} />
                </div>
            </Grid>
        </Grid>
    );

};

export default Leaderboard;